import { useState, useCallback } from 'react';
import { u as useDefaultValue } from './use-default-value.js';

const useFormField = ({
  defaultValue,
  value: externalValue,
  onChange,
  onFocus,
  onBlur,
  disabled,
  readOnly
}) => {
  const [value, setValue] = useDefaultValue(defaultValue, externalValue);
  const [focus, setFocus] = useState();
  const handleChange = event => {
    if (onChange) {
      onChange(event);
    }
    if (setValue) {
      setValue(event.target.value);
    }
  };
  const handleFocus = useCallback(event => {
    if (!readOnly && !disabled) {
      setFocus(true);
    }
    if (onFocus) {
      onFocus(event);
    }
  }, [disabled, onFocus, readOnly]);
  const handleBlur = useCallback(event => {
    setFocus(false);
    if (onBlur) {
      onBlur(event);
    }
  }, [onBlur]);
  return {
    value,
    focus,
    handleChange,
    handleFocus,
    handleBlur
  };
};

export { useFormField as u };
//# sourceMappingURL=use-form-field.js.map
